import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Input, TextArea, Select } from './ui/FormControls';
import SafeIcon from '../common/SafeIcon';

const StepRenderer = ({ section, formData, handleInputChange }) => {
  if (!section) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className="space-y-10"
    >
      <header className="space-y-6">
        <div className="flex items-center gap-5">
          <div className="w-14 h-14 bg-blue-600 rounded-[22px] flex items-center justify-center shadow-lg shadow-blue-100 text-white">
            <SafeIcon name={section.icon || 'Briefcase'} className="w-7 h-7" />
          </div>
          <h2 className="text-4xl font-black text-slate-900 tracking-tight">{section.title}</h2>
        </div>
        
        {section.consultantMessage && (
          <div className="bg-slate-50 border border-slate-100 p-6 rounded-[32px] flex gap-5">
            <div className="w-10 h-10 bg-white border border-slate-100 rounded-2xl flex items-center justify-center text-blue-500 shadow-sm shrink-0">
              <SafeIcon name="MessageSquare" className="w-5 h-5" />
            </div>
            <p className="text-[15px] font-medium text-slate-600 leading-relaxed italic">
              "{section.consultantMessage}"
            </p>
          </div>
        )}
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-10">
        {section.fields?.map((field) => {
          const isFullWidth = field.width === 'full';
          const containerClass = isFullWidth ? 'col-span-1 md:col-span-2' : 'col-span-1';

          const commonProps = {
            label: field.label,
            name: field.name,
            value: formData[field.name],
            onChange: handleInputChange,
            placeholder: field.placeholder,
            helperText: field.helperText,
            required: field.required
          };

          return (
            <div key={field.name} className={containerClass}>
              {field.type === 'text' && <Input {...commonProps} />}
              {field.type === 'textarea' && <TextArea {...commonProps} />}
              {field.type === 'select' && <Select {...commonProps} options={field.options || []} />}
            </div>
          );
        })}
      </div>
    </motion.div>
  );
};

export default StepRenderer;